export default __webpack_public_path__ + "static/media/thumbnail.e55a22bc.png";